<script>
    export default {
        props: {
            execute: {
                type: Function,
                required: true
            }
        },
        mounted () {
            const listener = (e) => {
                if (e.key === 'Escape') {
                    this.execute()
                }
            }

            document.addEventListener('keydown', listener)

            this.$once('hook:beforeDestroy', () => {
                document.removeEventListener('keydown', listener)
            })
        },
        render () {
            return this.$slots.default[0]
        }
    }
</script>
